<em-auth-wrapper>
  <form
    [formGroup]="forgotForm"
    (ngSubmit)="onSubmit()"
    autocomplete="off"
    >
    <mat-form-field appearance="outline" class="em-form-field">
      <mat-label>Email</mat-label>
      <input
        matInput
        type="email"
        id="email"
        placeholder="mail@example.com"
        formControlName="email"
        autofocus
        />
      @if (sent) {
        <mat-hint>Please check your email.</mat-hint>
      }
      @if (forgotForm.get('email')?.hasError('required')) {
        <mat-error emError="required" />
      }
      @if (forgotForm.get('email')?.hasError('email')) {
        <mat-error emError="email" />
      }
    </mat-form-field>

    <button
      emsysButton
      appearance="primary"
      [showLoader]="loading$|async"
      [disabled]="!forgotForm.valid"
      class="w-full"
      >
      {{sent ? 'Resent' : 'Send'}} reset link
      <svg class="w-6 h-6 ml-auto">
        <use xlink:href="assets/icons/symbols.svg#arrow-right"></use>
      </svg>
    </button>
  </form>

  <ng-template teleport="greet">
    <div class="flex flex-col min-h-full">
      <h1 class="text-4xl font-bold">
        Sales Portal
      </h1>

      <div class="flex items-center font-bold text-xl">
        <div class="h-[2px] w-5 bg-blue-50/25 mr-2.5"></div>
        Forgot password?
      </div>

      <div class="mt-auto">
        Back to
        <a routerLink="/login" class="font-bold">
          Sign In
        </a>
      </div>
    </div>
  </ng-template>
</em-auth-wrapper>
